// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_CancelarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /contratos/cancelar/:id — cancela um contrato ainda em assinatura (Full). */
import { registerContract } from './validate'

export interface Contratos_CancelarInput {
motivo?: string
}

registerContract('Contratos_CancelarInput', {
  motivo: { type: 'string',  required: false },
})
